import { render } from "./BindingPopup.vue?vue&type=template&id=2e4ef69b"
import script from "./BindingPopup.vue?vue&type=script&lang=js"
export * from "./BindingPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__